import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { selectCouponBetAmountV2, selectUserCurrency, useLocalizedNumberFormatters } from '@mwl/core-lib';
import type { BaseFormFieldProps } from '@/components/FormField/FormField';
import { FormField } from '@/components/FormField/FormField';
import { useTypedSelector } from '@/hooks';
import type { CouponSumFieldProps } from './CouponSumField.types';
import styles from './CouponSumField.module.scss';
const filedClasses: BaseFormFieldProps['classes'] = {
  componentWrapper: styles.fieldInput,
  component: styles.input
};
export const CouponSumField: FC<CouponSumFieldProps> = ({
  className,
  onChange,
  onBlur,
  onFocus
}) => {
  const {
    t
  } = useTranslation('sport');
  const betAmount = useTypedSelector(selectCouponBetAmountV2);
  const currency = useTypedSelector(selectUserCurrency);
  const {
    currencyDecimalSeparator
  } = useLocalizedNumberFormatters();
  const inputPrefix = <span className={styles.inputAffix}>{t('coupon.amount_input_prefix', 'Bet')}</span>;
  const inputPostfix = <span className={styles.inputAffix}>{currency}</span>;
  return <FormField as="numberFormat" value={betAmount ?? ''} onValueChange={onChange} onBlur={onBlur} classes={filedClasses} onFocus={onFocus} className={className} allowNegative={false} decimalScale={2} isNumericString prefix={inputPrefix} postfix={inputPostfix} decimalSeparator={currencyDecimalSeparator} data-sentry-element="FormField" data-sentry-component="CouponSumField" data-sentry-source-file="CouponSumField.tsx" />;
};